store.admin.products = {};
store.admin.products.initAttributes = function() {
	var $form = $('#attributeValues');
	$form.find('.isReq').change(function(){
		var $t = $(this);
		var v = parseInt($t.val());
		if (v > 0) {
			$(this).removeClass('bad');
		}
		else {
			$(this).addClass('bad');
		}
	}).trigger('change');
};

store.admin.initProductOptions = function(sel) {
	$(sel + " .elm").each(function(){
		$('<span class="handle"></span>').prependTo($(this));
	});
	$(sel).sortable({
		'handle': 'span.handle'
	});
};
store.admin.initProductCategories = function(placeholder) {
	var $form = $('#productForm');
	var $elm = $form.find('#elm_categories');
	var $wrap = $elm.find('.wrap');
	var $items = $wrap.find('.lmnt label');
	var $search = $('<div/>').addClass('search');
	var $input = $('<input/>').attr('type', 'text');
	$input.css({
		'width': '75%',
		'margin-bottom': '6px'
	});
	$wrap.css('height', $wrap.height() + 'px');
	$input.attr('placeholder', placeholder);
	$search.append($input);
	$input.keyup(function(e) {
		var $this = $(this);
		if (e.keyCode === 13) {
			return false;
		}
		if (e.keyCode === 27) {
			$this.val('');
		}
		var t = $this.val().toLowerCase();
		$items.hide().filter(function(){
			return $(this).text().toLowerCase().indexOf(t) !== -1;
		}).show();
		return false;
	}).keypress(function(e) {
		if (e.keyCode === 13) {
			e.preventDefault();
			return false;
		}
	});
	$wrap.before($search);
};

store.admin.initProductCustomizations = function() {
	var $form = $('#productForm');
	var $selectElm = $form.find('#elm_customization');
	var $select = $selectElm.find('#customization');
	var url = $select.data('opturl');

	var $optsWrap = $('<div/>').addClass('optsWrap');
	$selectElm.after($optsWrap);
	var $optsLabel = $('<div/>').addClass('label');
	$optsWrap.append($optsLabel);
	var $optsDiv = $('<div/>');
	$optsWrap.append($optsDiv);

	$select.change(function(){
		var val = $select.val();
		if (!val) {
			// hide options
			$optsWrap.hide();
		}
		else {
			$optsDiv.load(url, {c: val}, function() {
				$optsLabel.text($select.find('option[value=' + val + ']').text());
				$optsWrap.show();
				$optsDiv.find(':input').each(store.admin.addInitialValue);
			});
		}
	}).trigger('change');
};

store.admin.initProductTypes = function() {
	var $form = $('#productForm');
	var $selectType = $form.find('#productType');
	if ($selectType.length > 0) {
		var $needType = $form.find(':input.needProductType');
		$selectType.change(function(){
			var val = parseInt($(this).val());
			$needType.parents('.elm').hide();
			$needType.filter(function() {
				return parseInt($(this).data('needproducttype')) === val;
			}).parents('.elm').show();
		}).trigger('change');
	}
};
